// extracted by mini-css-extract-plugin
export var numpadContainer = "_t0-1";
export var phoneButton = "_t0-0";